import React from "react";
import { Link } from "react-router-dom";

/**
 *
 * @param {children} children
 * @param {link} href
 * @param {size} size
 * @param {classe} classe
 * @param {rounded} rounded
 * @param {color} color
 * @returns
 */
const ButtonHref = (props) => {
  const { children, target, size, href, classe, color } = props;

  let textSize, padding, backgound;

  //size
  if (size === "big") {
    textSize = "text-sm md:text-lg";
    padding = "py-4 px-6 md:px-8";
  } else if (size === "small") {
    textSize = "text-xs";
    padding = "py-3.5 px-5";
  } else {
    textSize = "text-base";
    padding = "py-4 px-4 md:py-5 lg:px-6";
  }

  if (color === "secondary") backgound = "bg-secondary";
  else if (color === "white") backgound = "bg-white text-secondary";
  else backgound = "bg-primary hover:bg-primary-dark";

  return (
    <a
      target={target && target}
      href={href}
      className={`${classe} ${backgound} ${textSize} ${padding} animate  inline-block rounded-lg text-xs font-medium text-white `}
    >
      {children}
    </a>
  );
};

export default ButtonHref;
